import { render } from "./NewGroupForm.vue?vue&type=template&id=5ba6ff15&scoped=true"
import script from "./NewGroupForm.vue?vue&type=script&lang=js"
export * from "./NewGroupForm.vue?vue&type=script&lang=js"

import "./NewGroupForm.vue?vue&type=style&index=0&id=5ba6ff15&scoped=true&lang=scss"

import exportComponent from "/home/misha/Рабочий стол/sportkit-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ba6ff15"]])

export default __exports__